// extracted by mini-css-extract-plugin
export default {"message":"styles_message__fd307","arrow":"styles_arrow__mTx27"};